import { PersonTypeDto } from "../dtos";

export class PersonType {
  id: number;
  name: string;
  description?: string;
  isSystem?: boolean;
  activityIdToAllocatableMap?: Record<number, boolean>;

  constructor(dto: PersonTypeDto) {
    this.id = dto.id;
    this.name = dto.name;
    this.description = dto.description;
    this.isSystem = !!dto.is_system;

    if (dto.activities) {
      this.activityIdToAllocatableMap = dto.activities.reduce(
        (acc, { activity_id, is_allocatable }) => {
          acc[activity_id] = is_allocatable;
          return acc;
        },
        {} as Record<number, boolean>
      );
    }
  }
}
